module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inp-table noselect h-100"
  }, [_c('div', {
    staticClass: "thead"
  }, [_c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th cln-salarie",
    attrs: {
      "title": "Salarié"
    },
    on: {
      "click": function($event) {
        _vm.orderBy('NomSalarie')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Salarié")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('NomSalarie', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('NomSalarie', true)
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "th cln-debut",
    attrs: {
      "title": "Début"
    },
    on: {
      "click": function($event) {
        _vm.orderBy('DateDebut')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Début")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('DateDebut', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('DateDebut', true)
  })])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "tbody"
  }, [_vm._m(4), _vm._v(" "), _vm._l((_vm.annulationEnAttente), function(absenceEmploye) {
    return _c('div', {
      staticClass: "tr"
    }, [_c('div', {
      staticClass: "td cln-salarie",
      attrs: {
        "title": absenceEmploye.PrenomSalarie + ' ' + absenceEmploye.NomSalarie
      }
    }, [(absenceEmploye.Photo != '') ? _c('span', {
      staticClass: "resp-hide float-left"
    }, [_c('img', {
      staticClass: "mr-2",
      attrs: {
        "alt": "Photo",
        "src": absenceEmploye.Photo
      }
    })]) : _c('span', {
      staticClass: "resp-hide float-left"
    }, [_c('span', {
      staticClass: "logo pre mr-2",
      style: ({
        background: _vm.randomColor(absenceEmploye.IdSalarie)
      })
    }, [_vm._v("\n                            " + _vm._s(absenceEmploye.Initiales) + "\n                        ")])]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(absenceEmploye.NomSalarie) + " " + _vm._s(absenceEmploye.PrenomSalarie))])]), _vm._v(" "), _c('div', {
      staticClass: "td cln-type cln-center",
      attrs: {
        "title": absenceEmploye.LibelleTypeAbsence
      }
    }, [(absenceEmploye.CodeTypeAbsence == 'JCONG') ? _c('span', [_c('span', {
      staticClass: "badge text-center text-white",
      style: ({
        background: absenceEmploye.Couleur
      })
    }, [_vm._v("\n                            CP\n                        ")])]) : (absenceEmploye.CodeTypeAbsence == 'JRECU') ? _c('span', [_c('span', {
      staticClass: "badge text-center text-white",
      style: ({
        background: absenceEmploye.Couleur
      })
    }, [_vm._v("\n                            RTT\n                        ")])]) : (absenceEmploye.CodeTypeAbsence == 'HCSS') ? _c('span', [_c('span', {
      staticClass: "badge text-center text-white",
      style: ({
        background: absenceEmploye.Couleur
      })
    }, [_vm._v("\n                            HSS\n                        ")])]) : (absenceEmploye.CodeTypeAbsence == 'JTELE') ? _c('span', [_c('span', {
      staticClass: "badge text-center text-white",
      style: ({
        background: absenceEmploye.Couleur
      })
    }, [_vm._v("\n                            TL\n                        ")])]) : _c('span', [_c('span', {
      staticClass: "badge text-center text-white",
      style: ({
        background: absenceEmploye.Couleur != null ? absenceEmploye.Couleur : _vm.grey
      })
    }, [_vm._v("\n                            " + _vm._s(absenceEmploye.CodeTypeAbsence) + "\n                        ")])])]), _vm._v(" "), _c('div', {
      staticClass: "td cln-debut text-center"
    }, [_c('span', {
      staticClass: "fas fa-sign-out-alt mr-1 resp-hide",
      staticStyle: {
        "color": "#2ecc71"
      }
    }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("moment")(absenceEmploye.DateDebut, "DD/MM/YY")) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-fin text-center"
    }, [_c('span', {
      staticClass: "fas fa-sign-in-alt mr-1 resp-hide",
      staticStyle: {
        "color": "#ff7675"
      }
    }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("moment")(absenceEmploye.DateFin, "DD/MM/YY")) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-duree"
    }, [_c('span', {
      staticClass: "far fa-clock mr-1 resp-hide"
    }), _vm._v(" "), (absenceEmploye.NombreJours > 0) ? _c('span', {
      attrs: {
        "title": absenceEmploye.NombreJours + ' jour(s)'
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(absenceEmploye.NombreJours) + " jour(s)\n\t\t\t\t\t")]) : (absenceEmploye.NombreHeures > 0) ? _c('span', {
      attrs: {
        "title": absenceEmploye.NombreHeures + ' heure(s)'
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(absenceEmploye.NombreHeures) + " heure(s)\n\t\t\t\t\t")]) : (absenceEmploye.NombreMois > 0) ? _c('span', {
      attrs: {
        "title": absenceEmploye.NombreMois + ' mois'
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(absenceEmploye.NombreMois) + " mois\n\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "td cln-validation cln-center"
    }, [_c('div', {
      staticClass: "inp-button-group-outline"
    }, [_c('button', {
      staticClass: "button green",
      attrs: {
        "type": "button",
        "data-testid": "manager-cancelRequestsList-accept-button"
      },
      on: {
        "click": function($event) {
          _vm.validerAnnulationAbsence(absenceEmploye)
        }
      }
    }, [_c('span', {
      staticClass: "fas fa-check"
    })]), _vm._v(" "), _c('button', {
      staticClass: "button red",
      attrs: {
        "type": "button",
        "data-testid": "manager-cancelRequestsList-decline-button"
      },
      on: {
        "click": function($event) {
          _vm.refuserAnnulationAbsence(absenceEmploye)
        }
      }
    }, [_c('span', {
      staticClass: "fas fa-times"
    })])])])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "th cln-type nohover",
    attrs: {
      "title": "Type"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Type")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "th cln-fin nohover",
    attrs: {
      "title": "Fin"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Fin")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "th cln-duree nohover",
    attrs: {
      "title": "Durée"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Durée")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "th cln-validation nohover",
    attrs: {
      "title": "Validation"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Validation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "section cln-salarie"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-type"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-debut"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-fin"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-duree"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-validation"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4035a60a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gestionDesAbsences/listeDesDemandes/espaceManager/tableaux/annulationEnAttente/annulationEnAttente.vue.html
// module id = K/4R
// module chunks = 2